module.exports = __webpack_public_path__ + "static/media/settings.03f8164c.svg";